import React, {Component} from 'react';
import classnames from 'classnames';

import {
    mapCardTypeToCss
} from "../../lib/payment-method-util"

class PaymentMethodLastUsedFields extends Component {
    render() {
        const {lastUsedPm, config} = this.props,
            {paymentConfig, messages} = config;
        const pm = paymentConfig.paymentMethods.find(pm => (pm.code === lastUsedPm.type));
        if (!pm) {
            return <div data-debug="No PM identified"/>;
        }
        // we have category, and name
        const categoryCode = pm.categoryCode;
        if (categoryCode === 'CC' || categoryCode === 'DC') {
            // Credit Card display
            return (
                <div className="col-12">
                    <div className="card-container">
                        <div className="pm-card-chip"/>
                        <p className="pm-info card-number">{lastUsedPm.accountNumber}</p>
                        <p className="pm-info card-exp-label">Valid <br/>Thru</p>
                        <p className="pm-info card-exp-date">{lastUsedPm.creditCardExpiryDate.month}<span className="card-sep">/</span>{lastUsedPm.creditCardExpiryDate.year.substr(-2)}</p>
                        <p className="pm-info card-name">
                            {lastUsedPm.cardHolderName}
                        </p>
                        <p className="pm-info card-type">
                        <span className={classnames("pm-icon", mapCardTypeToCss(pm.code))}>
                            {pm.description}
                        </span>
                        </p>
                    </div>
                </div>
            );
        }
        if (categoryCode === 'DD') {
            return (
                <div className="col-12">
                    <div className="card-container echeck">
                        <p className="pm-info echeck-type">{pm.description}</p>
                        <p className="pm-info account-holder-name">{lastUsedPm.cardHolderName}</p>
                        <p className="pm-info bank-name">{lastUsedPm.fiName}</p>
                        <p className="pm-info routing-number">{lastUsedPm.maskedRoutingNumber}</p>
                        <p className="pm-info bank-account-number">{lastUsedPm.maskedAccountNumber}</p>
                        <div className="echeck-decoration-overlay">
                            <div className="echeck-decoration-line1"/>
                            <div className="echeck-decoration-line2"/>
                            <div className="echeck-decoration-line3"/>
                            <div className="echeck-decoration-line4"/>
                            <div className="echeck-decoration-box1"/>
                            <div className="echeck-decoration-icon-lock">
                                <i className="fa fa-lock" aria-hidden="true"/>
                            </div>
                            <div className="echeck-decoration-icon-bank">
                                <i className="fa fa-university" aria-hidden="true"/>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="col-12">
                <div data-debug={`Unknown category: ${categoryCode}`}/>
            </div>
        );
    }
}

export default PaymentMethodLastUsedFields
